import { Component, OnDestroy, ViewChild, HostListener, OnInit, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService, SelectItem, MenuItem } from 'primeng/api';
import { AppComponent } from '../../../app.component';
import { AppMainComponent } from '../main-panel/app.main.component';
import { AuthService, StorageService, CommonService } from '../../service';
import { SubSink } from 'subsink';
import { MultiSelect } from 'primeng/multiselect';
import { TieredMenu } from 'primeng/tieredmenu';
import { UserControlService } from '../../../../app/shared/service/userControl/user-control.service';
import { AppRoutes } from "../../../../app/shared/lib/api-constant";
import { UserSetting } from '../../lib/types/general';
import { SharedFilterService } from '../../service/filter-service/shared-filter.service';
import { ToastService, ToastType } from '../../service/toast/toast.service';
import {BdpDialogTypes, DialogService } from '../../service/dialog/dialog.service';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html',
    styleUrls: ['./app.topbar.component.scss'],
    standalone :false
})
export class AppTopBarComponent implements OnDestroy, OnInit, AfterViewInit {
    @ViewChild('multiSelectDropdown') multiSelectDropdown: MultiSelect;
    @ViewChild('tieredMenu') tieredMenu: TieredMenu;
    reference: SelectItem[] = [];
    companyModel: any[] = [];
    selectedCompanyCode: string | null = null;
    userDetails: Record<string, any> = {};
    display = false;
    private subscription = new SubSink();
    selectedDrop: SelectItem | null = null;
    notificationVisibility = false;
    userName: string="";
    userApps: any[] = [];
    bdpApps: any[] = [];
    isPanelCloseAllowed = true;
    selectedCompanies: any[] = [];
    AppRoutes = AppRoutes;
    isCompanyDropdownDisabled = false;
    selectedCompanyCodes: string[] = [];
    companyDropdownSelected = false;
    selectedItemsLabel = 'All Companies';
    downloadManualItems: MenuItem[] = [];
    companies: any;
    items: MenuItem[] | undefined;
    private subscriptions = new SubSink();
    @HostListener('window:click', ['$event'])
    handleWindowClick(event: MouseEvent) {
        const filterElem = document.getElementById('notificationList');
        const filterElemIcon = document.getElementById('bdpNotificationIcon');
        if (filterElem && !filterElem.contains(event.target as Node) && !(filterElemIcon && filterElemIcon.contains(event.target as Node))) {
            this.notificationVisibility = false;
        }
    }

    constructor(
        public appMain: AppMainComponent,
        public app: AppComponent,
        private commonService: CommonService,
        private userControlService: UserControlService,
        private sharedFilterService: SharedFilterService,
        private toastService: ToastService,
        private appService: UserControlService,
        private storageService: StorageService,
        private authService: AuthService,
        private dialogService: DialogService,
        private router: Router,
    ) {
        let userData = this.storageService.getItem('userData');
        if(userData){
        this.userName =userData.firstNm + ' ' + userData.lastNm;
        }
        this.appService.$userAppsList.subscribe(apps => {
            if (apps) {
                this.bdpApps = [...apps];
                this.setApplications();
            }
        })
    
        this.downloadManualItems = [
            {
                label: 'My Account',
                icon: 'pi pi-user',
                styleClass: 'menu-item',
                command: () => this.authService.profileRedirect()
            },
            {
                label: 'Change Password',
                icon: 'pi pi-key',
                styleClass: 'menu-item',
                command: () => this.authService.changePasswordRedirect()

            }, 
            {
                label: 'User Configuration',
                icon: 'pi pi-cog',
                items: [
                    {
                        label: 'Port Configuration',
                        icon: 'fa-solid fa-anchor',
                        command: (event) => this.onMenuItemClick('port-configuration')
                    },
                    {
                        label: 'Status Configuration',
                        icon: 'fa-solid fa-truck-container-empty',
                        command: (event) => this.onMenuItemClick('status-configuration')
                    }
                ]
            },
            {
                label: 'Help',
                icon: 'pi pi-question',
                // command: (event) => this.onMenuItemClick('faq')
            },
            {
                label: 'Sign Out',
                icon: 'pi pi-power-off',
                styleClass: 'menu-item',
                command: () => {
                    this.dialogService.showDialog({
                        type: BdpDialogTypes.SIGN_OUT,
                        visibility: true,
                        width: '550px',
                        header: 'Sign Out Warning',
                        body: `Are you sure you want to Sign Out?<br/><br/>
                               Signing out will automatically close any other Smart Suite application that you have signed into via Single Sign In.`,
                        action: 'Sign Out',
                        reject: 'Stay Signed On',
                        onAccept: () => {
                            this.signOut();
                        },
                        onReject: () => { }
                    });
                }
            }
        ];
    }
    onMenuItemClick(menu: string) {
        switch (menu) {
            case 'download':
                // this.commonService.getCustomerUserManual().subscribe((res: any) => {
                //     if (res && res.status == 200) {
                //         this.openPdfInNewTab(res.data);
                //     }
                // });
                break;
            case 'faq':
                window.open('https://psabdp.com/smartsupport', '_blank');
                break;
            case 'port-configuration':
                this.appMain.onTopbarSubItemClick(event, AppRoutes.User.PORT_CONFIGURATION);
            break;
            case 'status-configuration':
                this.appMain.onTopbarSubItemClick(event, AppRoutes.User.STATUS_CONFIGURATION);
                break;
            default:
                break;
        }
    }

    signOut() {
        this.authService.logout();
    }

    openPdfInNewTab(url: string) {
        window.open(url, '_blank');
    }

    navigateToProfile(route: string) {
        this.appMain.onTopbarSubItemClick(event, route);
    }

    setProfileOptions() {

    }
    onCompanyPanelOptionChange(event: any) {
        if (this.selectedCompanyCodes.length) {
            this.updateSelectedItemsLabel();
        }
    }

    

    onCompanyPanelHide(event: Event) {
        if (!this.selectedCompanyCodes.length) {
            this.showNoCompanySelectedError();
            console.log('No company selected');
            setTimeout(() => {
                this.multiSelectDropdown.show();
            }, 500);
            return;
        }
        else {
            this.sharedFilterService.updateSelectedCompanies(this.selectedCompanyCodes);
        }
    }


    ngAfterViewInit(): void { }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    private setApplications() {
        let userData = this.storageService.getItem('userData');
        let assignedApps: any[] = userData.userApps?.map((a:any) => a.id?.appCd);
        let defaultApps = ["HUB"];
        const currentApp = ["DETENTION_DEMURRAGE","DETENTION_DEMURRAGE_STAGE"];
        this.userApps = this.bdpApps.filter(app => {
            if (currentApp.includes(app.value)) {
                app.logoLight = app.logoDark;
                app.isSelected = true;
            }
            if (defaultApps.includes(app.value))
                return true;
            if (app.activeYn == 'Y')
                return assignedApps.includes(app.value);
            else
                return false;
        })
    }



    showNoCompanySelectedError() {
        this.toastService.showToast(ToastType.ERROR, `At least 1 company should be selected.`, 5000);
    }

    redirectTo(appUrl:any) {
        if (appUrl != "") {
            let a = document.createElement('a');
            a.target = '_blank';
            a.href = appUrl;
            a.click();
        }
    }

    getCompanyList() {
        this.subscription.sink = this.userControlService.getStoredCompanyDetails().subscribe((res: any) => {
            if (res && res.status == 200) {
                this.reference = res.data.map((company: any) => {
                    return { label: company.companyName, value: company.companyCode };
                });
            }
        });
    }

    updateSelectedItemsLabel() {
        if (this.selectedCompanyCodes.length === this.companies.length) {
            this.selectedItemsLabel = 'All Companies';
        } else {
            const selectedLabels = this.companies
                .filter((company: any) => this.selectedCompanyCodes.includes(company.companyCode))
                .map((company: any) => company.companyName);
            this.selectedItemsLabel = selectedLabels.join(', ');
        }
    }

    ngOnInit() {
        this.subscriptions.add(
            this.sharedFilterService.companyList$.subscribe((list) => {
                this.companies = list;
                this.isCompanyDropdownDisabled = list?.length === 0 ? true :false;
                // Select all companies by default
                this.selectedCompanyCodes = list?.map(company => company.companyCode);
                this.sharedFilterService.updateSelectedCompanies(this.selectedCompanyCodes);
                this.updateSelectedItemsLabel();
            })
        );
        if(this.companies.length==0){
            this.router.navigate([AppRoutes.AuthAbstract.MAINTENANCE]);
        }
    }

}